import React, { useEffect, useState } from 'react'
import TextInput from '../../atoms/text-input/TextInput'
import Button from '../../atoms/button/Button';
import { HUB_ENDPOINTS } from '../utils/endpoints';
import axios from 'axios';
import { getAuthToken } from '../utils/hub_client';
import userAvatar from '../../assets/images/user-avatar.png';
import './EditProfileModal.scss';

const EditProfileModal = ({ audience, modalClose }) => {
  const contentWidth = {
    width: '100%',
    maxWidth: 420,
    margin: '0 auto'
  };

  const initialDetailsValue = {
    id: "",
    first_name: "",
    last_name: "",
    company_name: "",
    city: "",
    state: "",
    email: "",
  }
  const [userDetails, setUserDetails] = useState(initialDetailsValue);
  const [avatarFile, setAvatarFile] = useState(null);
  const [avatarPreviewUrl, setAvatarPreviewUrl] = useState(userAvatar);

  useEffect(() => {
    if (audience) {
      setUserDetails({
        ...initialDetailsValue,
        ...audience,
        first_name: audience.first_name || '',
        last_name: audience.last_name || '',
        company_name: audience.company_name || '',
        city: audience.city || '',
        state: audience.state || '',
        email: audience.email || ''
      });
      setAvatarFile(null);
      setAvatarPreviewUrl(audience.avatar_url || userAvatar);
    }
  }, [audience]);

  useEffect(() => (
    () => {
      if (avatarPreviewUrl && avatarPreviewUrl.startsWith('blob:')) {
        URL.revokeObjectURL(avatarPreviewUrl);
      }
    }
  ), [avatarPreviewUrl]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUserDetails((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleAvatarChange = (event) => {
    const nextFile = event.target.files?.[0];
    if (!nextFile) return;

    if (avatarPreviewUrl && avatarPreviewUrl.startsWith('blob:')) {
      URL.revokeObjectURL(avatarPreviewUrl);
    }

    setAvatarFile(nextFile);
    setAvatarPreviewUrl(URL.createObjectURL(nextFile));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const formData = new FormData();
      const payload = {
        details: { ...userDetails },
      }
      for (const key in payload) {
        if (payload.hasOwnProperty(key)) {
          formData.append(key, JSON.stringify(payload[key]));
        }
      }
      if (avatarFile) {
        formData.append('avatar', avatarFile);
      }
      const response = await axios.put(HUB_ENDPOINTS.UPDATE_CURRENT_USER, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json',
          'Authorization': `Bearer ${getAuthToken()}`
        },
      });
      if (response.status === 200) {
        alert(response.data.message);
        modalClose();
        window.location.reload();
      }
      else {
        alert("Something went wrong");
      }
    } catch (error) {
      console.error("Error updating profile:", error);
    }
  };

  return (
    <div
      className="modal fade edit_profile_modal"
      id="editProfileModal"
      tabIndex="-1"
      role="dialog"
      aria-labelledby="myModalLabel2"
    >
      <div
        className="modal-dialog"
        role="document"
        id="modal_dialog"
      >
        <div className="modal-content">
          <div className="modal-body" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <div
              className='m-head'
              style={{
                ...contentWidth,
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                textAlign: 'center'
              }}
            >
              <img src={avatarPreviewUrl || userAvatar} alt="Profile avatar" />
              <p className='modal-heading'><b>My Account</b></p>
              <p style={{ margin: 0, textAlign: 'center' }}>Adding your information helps personalize your experience</p>
            </div>
            <form onSubmit={handleSubmit} style={contentWidth}>
              <div className="m-body" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 16, width: '100%' }}>
                <label className="edit_profile_modal__avatar_upload">
                  <span>Profile photo</span>
                  <input
                    type="file"
                    accept="image/*"
                    onChange={handleAvatarChange}
                  />
                </label>
                <TextInput
                  name={'first_name'}
                  placeholder={'First name'}
                  value={userDetails.first_name}
                  onChange={handleChange}
                />
                <TextInput
                  name={'last_name'}
                  placeholder={'Last name'}
                  value={userDetails.last_name}
                  onChange={handleChange}
                />
              </div>
              <hr style={{ width: '100%', margin: '24px 0 20px' }} />
              <div className="m-bottom" style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
                <Button
                  type="submit"
                  className="btn_submit"
                  style={{ width: '100%' }}
                >
                  Update Profile
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  )
}

export default EditProfileModal
